import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const Tag = styled.div`
  background: ${colors.darkBlue};
  border-radius: ${({ size }) => size || 10}px;
  font-size: ${({ size }) => size || 9}px;
  font-weight: bold;
  padding: ${({ size }) => (size ? size * 0.25 : 2)}px ${({ size }) => (size ? size * 0.75 : 7)}px;
  color: ${colors.white};
  text-transform: uppercase;

  ${({ tagColor }) =>
    tagColor &&
    css`
      background: ${tagColor} !important;
    `}

  ${({ isTestTag }) =>
    isTestTag &&
    css`
      margin-right: 0px !important;
    `}
`;

export const TagsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
  gap: 5px;
  flex: 0 0 ${({ size }) => size * 2 || 17}px;
  margin-top: 10px;

  ${({ isTestTag }) =>
    isTestTag &&
    css`
      display: inline-table;
      margin-top: 0px;
    `}
`;
